export const getCityPointById = (points, id) => points.find((item) => item.id === id);
export const getAdress = (item, cityName) => {
  if (!item) return null;
  const {
    street, house, room, entrance, floor, area, privateHouse,
  } = item;
  if (!street) return null;
  return `${cityName ? `${cityName}, ` : ''}${area ? `${area}, ` : ''}${street} ${house}${room ? `, квартира ${room}` : ''}${floor ? `, этаж ${floor}` : ''}${entrance ? `, подъезд ${entrance}` : ''}${privateHouse ? ' (частный дом)' : ''}`;
};
